import { Button } from "@/components/ui/button";
import {
  Command,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { cn } from "@/lib/utils";
import { ChevronDown } from "lucide-react";
import { useState } from "react";

const Selector = ({
  options,
  placeholder = "Select",
  selected,
  setSelected,
  size,
}: any) => {
  const [inputValue, setInputValue] = useState("");
  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="ghost" className="w-full justify-between h-fit p-0">
          {selected?.icon && <img src={selected?.icon} className="w-4 h-4" />}
          {selected?.label ?? placeholder}

          <ChevronDown className={`ml-auto ${open && "rotate-180"}`} />
        </Button>
      </PopoverTrigger>
      <PopoverContent
        className={cn("w-full", size ? `w-[${size}]` : "min-w-[23rem]")}
      >
        <Command>
          <div
            className="flex items-center 
               border-border p-2 border-[1px] rounded gap-2 w-full
              "
          >
            <CommandInput
              value={inputValue}
              onValueChange={setInputValue}
              placeholder="Search"
              className="placeholder:text-gray-70 outline-none  p-0 border-none rounded  bg-transparent h-fit w-full border-0"
            />
          </div>

          <CommandList className="w-full">
            {options
              ?.filter((option: any) =>
                option.label.toLocaleLowerCase().startsWith(inputValue.toLocaleLowerCase())
              )
              ?.map((option: any) => (
                <CommandItem
                  key={option?.label}
                  className={`p-2 text-sm hover:bg-primary hover:text-white z-50 flex items-center 
              ${option?.label?.toLowerCase() ===
                    selected?.label?.toLowerCase() && "bg-gray-2 text-white"
                    }
              ${option?.label?.toLowerCase().startsWith(inputValue)
                      ? "flex"
                      : "hidden"
                    }`}
                  onSelect={() => {
                    setSelected(option);
                    setInputValue("");
                    setOpen(false);
                  }}
                >
                  {option?.icon && <img src={option?.icon} />}
                  {option?.label}
                </CommandItem>
              ))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};

export default Selector;
